import Box from 'components/shared/Box'
import TicketRow from './TicketRow'
import { useAppSelector } from 'store/hooks'
import TicketItem from './TicketItem'
import { getDayNameAndDate } from 'helpers/dates'
import { CabanaWithDetails } from 'store/api-slice/types'

const NewCabanas = () => {
    const { cabanas } = useAppSelector((state) => state.selfcare)
    const { items } = useAppSelector((state) => state.selfcareCart)
    const { cabanas: newCabanas } = items

    const separatedNewCabanas = () => {
        const separatedCabanas: CabanaWithDetails[] = []

        // ignore already existed, but edited cabanas from cart - consider only newly added
        const changedBoxes =
            cabanas?.map((orderCabana) => orderCabana.changes?.detail.boxId) ||
            []
        const onlyNewCabanas = newCabanas.filter(
            ({ detail: { boxId } }) => boxId && !changedBoxes.includes(boxId)
        )

        // separate multiple Cabanas (quantity > 1) into single ones
        onlyNewCabanas.forEach((newCabana) => {
            Array.from(Array(newCabana.quantity || 0).keys()).forEach(() =>
                separatedCabanas.push(newCabana)
            )
        })

        return separatedCabanas
    }

    return (
        <>
            {!!newCabanas.length &&
                separatedNewCabanas().map((cabana, index) => {
                    const { totalPrice, cartItemId, detail, unitPrice } = cabana
                    const { date } = detail || {}

                    return (
                        totalPrice && (
                            <Box
                                gap={[16, 24]}
                                isFullWidth
                                key={`${cartItemId}-${index}`}
                            >
                                <TicketRow
                                    price={unitPrice || 0}
                                    key={`${cartItemId}${index}`}
                                >
                                    <Box gap={[16, 24]} isFullWidth>
                                        <TicketItem
                                            date={getDayNameAndDate({
                                                date,
                                            })}
                                            editedItem="newItem"
                                        >
                                            Cabana
                                        </TicketItem>
                                    </Box>
                                </TicketRow>
                            </Box>
                        )
                    )
                })}
        </>
    )
}

export default NewCabanas
